import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

const SiteHeader = () => {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
      isActive
        ? 'text-primary-800 bg-primary-100'
        : 'text-foreground-700 hover:text-primary-800 hover:bg-background-100'
    }`;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="hidden md:flex items-center justify-between bg-primary-900 text-background-50 text-xs px-6 py-1.5">
        <span className="flex items-center gap-2">
          <i className="ri-radar-line w-4 h-4 flex items-center justify-center" />
          第一现场 · 全网娱乐快讯聚合
        </span>
        <span className="flex items-center gap-4">
          <span>2026 年 9 月 10 日</span>
          <span className="text-primary-300">投稿邮箱 tips@baogua.example.com</span>
        </span>
      </div>

      <div className="flex items-center justify-between gap-4 px-4 md:px-6 h-16">
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <span className="w-10 h-10 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
            <i className="ri-fire-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black text-foreground-950">爆瓜爆料</span>
            <span className="text-[11px] text-foreground-500 mt-0.5">全网快讯 · 实时直击</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2 shrink-0">
          <Link
            to="/contact"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center" />
            我要爆料
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setOpen(false)}
                className={linkClass}
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink to="/contact" onClick={() => setOpen(false)} className={linkClass}>
              联系我们
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
};

export default SiteHeader;